import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FacilitySection } from '../components/FacilitySection';
import { CTASection } from '../components/CTASection';
import { motion } from 'framer-motion';
import { Wifi, Coffee, Shield, Users } from 'lucide-react';
export function FacilityPage() {
  useEffect(() => {
    document.title = "Facility | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const amenities = [{
    icon: Wifi,
    title: 'Free Wi-Fi',
    desc: 'Stay connected while you wait'
  }, {
    icon: Coffee,
    title: 'Parent Lounge',
    desc: 'Comfortable viewing area'
  }, {
    icon: Shield,
    title: 'Safety First',
    desc: 'Professional grade mats & equipment'
  }, {
    icon: Users,
    title: 'Spacious Floor',
    desc: '4,200 sq ft of training space'
  }];
  return <div className="bg-black min-h-screen" data-id="element-736">
      <Navigation data-id="element-737" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-738">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-739">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-740">
            World-Class <span className="text-[#00D4FF]" data-id="element-741">Facility</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-742">
            Train in a clean, safe, and professional environment designed to
            maximize your potential. Our dojo is your second home.
          </p>
        </motion.div>
      </div>

      <FacilitySection data-id="element-743" />

      {/* Amenities Grid */}
      <section className="py-20 bg-[#111]" data-id="element-744">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-745">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-746">
            Facility Amenities
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-747">
            {amenities.map((item, index) => <motion.div key={item.title} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800 hover:border-[#00D4FF]/50 transition-colors group" data-id="element-748">
                <div className="w-12 h-12 bg-[#00D4FF]/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#00D4FF] transition-colors duration-300" data-id="element-749">
                  <item.icon className="w-6 h-6 text-[#00D4FF] group-hover:text-black transition-colors duration-300" data-id="element-750" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-751">
                  {item.title}
                </h3>
                <p className="text-gray-400" data-id="element-752">{item.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-753" />
      <Footer data-id="element-754" />
    </div>;
}